import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import styled, { ThemeProvider } from "styled-components";
// @ts-ignore
import { ToastContainer } from "cwb-react";

import Routes from "./Routes";
import GaPageViews from "./components/GaPageViews";
import CWBRTheme from "./Theme/CWBRSTheme";
import { setLanguage } from "./service/UserService";
import { setBrowserLang } from "./helpers";
import {
  applySignedInLanguage,
  ensureFlowLanguage,
  isSubmissionPath,
} from "./components/Submission/common/flowLanguage";

import 'react-toastify/dist/ReactToastify.css';

const App: React.FC = () => {
  if (isSubmissionPath(window.location.pathname)) {
    // The submission flow: ?lang= or the browser, then the actor signed in in this tab. Not the
    // shared stored user setLanguage reads, which can be someone else's on this site. Only the
    // languages it is fully translated into; anything else gets it in English
    // (components/Submission/common/flowLanguage.ts).
    setBrowserLang();
    applySignedInLanguage();
    ensureFlowLanguage();
  } else {
    setLanguage();
  }

  return (
    <ThemeProvider theme={CWBRTheme}>
      <Wrapper>
        <BrowserRouter>
          {/* This react-router allows a Router one child only. */}
          <>
            <GaPageViews />
            <Routes />
          </>
        </BrowserRouter>
        <ToastContainer />
      </Wrapper>
    </ThemeProvider>
  );
};

const Wrapper = styled.div`
  * {
    font-family: ${(p) => p.theme["font-family"]};
  }

  a {
    color: ${(p) => p.theme.btnDarkBlue};
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
`;

export default App;
